import React from 'react';
import PropTypes from 'prop-types';
import SpectrumResultRow from 'components/results/SpectrumResultRow';
import { stringReplace } from 'utils';

//FIXME: SOF-617 requires the following imports to be moved to components/widget-components.scss
// due to lazy loading of the widget inside an iframe. Keeping this here for potential fix down the road.
// import 'components/results/SpectrumResult.scss';

const SpectrumResult = ({ result }) => {
  const { columns, rows, id } = result;

  const spectId = stringReplace(id, '/', '-');

  return (
    <div className="csw-r-spect">
      <div className="csw-r-spect-rows">
        {rows && rows.map((row, index) => {
          return (
            <SpectrumResultRow row={row} columns={columns}
                               key={`csw-r-spect-row-${spectId}-${index}`}/>
          );
        })}
      </div>
    </div>
  );
};

SpectrumResult.propTypes /* remove-proptypes */ = {
  result: PropTypes.object.isRequired
};

export default SpectrumResult;
